<template>
  <div class="etc-agreement">
    <section v-for="(item, index) in xyText" :key="index">
      <div :class="item.headline ? 'title' : ''">{{ item.headline }}</div>
      <div :class="type ? 'indent' : ''">
        <span>{{ item.head }}</span>
      </div>
      <div v-for="(subItem, subIndex) in item.subtitleandcontent" :key="subIndex">
        <div v-show="subItem.title" :class="subItem.title === '征信业务授权书' ? 'title' : 'subtitle'">{{ subItem.title }}</div>
        <div v-for="(contentItem, contentIndex) in subItem.content" :key="contentIndex">
          <p>{{ contentItem.subtitle }}</p>
          <img v-show="contentItem.imageSrc" class="docImg" :src="contentItem.imageSrc | transHTTP"/>
          <div v-for="(nextItem, nextIndex) in contentItem.next" :key="nextIndex" :class="nextItem.topSpace ? 'top-space' : ''">
            <p :class="nextItem.indent ? 'indent' : ''">{{ nextItem.nubtext }}</p>
            <div v-for="(lastItem, lastIndex) in nextItem.lastext" :key="lastIndex" :class="maxType ? '' : 'dot'">{{ lastItem.max }}</div>
          </div>
        </div>
      </div>
      <view class="last">{{ item.tail }}</view>
    </section>
  </div>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
// api
import SystemApi from '@/api/system.api'
// store
import {mapState} from 'vuex'
// config
import ETC from '@/config/etc.config'

export default {
  name: 'agreement',
  mixins: [FunMixin],
  components: {},
  data() {
    return {
      xyText: null,
      type: true,
      maxType: true
    }
  },
  computed: {
    ...mapState({
      currentIssuer: 'currentIssuer'
    })
  },
  methods: {
    setTitle(type, protocolName) {
      if (protocolName === 'USER_SERVE_PROTOCOL') {
        this.m_setPageTitle('用户服务协议')
      } else if (protocolName === 'OBU_USER_PLATEFORM_PROT') {
        this.m_setPageTitle('粤通用户协议')
      } else if ((type === '粤通卡') && (protocolName === 'OBU_USE_PROTOCOL')) {
        this.m_setPageTitle('粤通卡电子标签使用协议')
      } else if (protocolName === 'PAYMENT_ENTRUST') {
        this.m_setPageTitle('扣款授权委托书')
      } else if (protocolName === 'VALUE_ADDED_SERVICE') {
        this.type = false
        this.m_setPageTitle('基础服务协议')
      } else if (protocolName === 'USER_PRIVACY_PROTECTION_PROTOCOL') {
        this.m_setPageTitle('用户隐私保护政策')
      } else if (type === '青通卡' && protocolName === 'RECHARGE_OBU_USE_PROTOCOL') {
        this.m_setPageTitle('青通卡（储值）使用章程')
      } else if (type === '青通卡' && protocolName === 'OBU_USE_PROTOCOL') {
        this.m_setPageTitle('青通记账卡与电子标签使用协议')
      } else if (protocolName === 'KING_OBU_USE_PROTOCOL') {
        this.m_setPageTitle('ETC王卡与电子标签使用协议')
      } else if (protocolName === 'KING_USER_SERVE_PROTOCOL') {
        this.m_setPageTitle('ETC王卡用户服务协议')
      } else if (protocolName === 'COMPANY_ETC_APPLY_COMMITMENT') {
        this.m_setPageTitle('')
      } else if (protocolName === 'MEMBER_SERVICE_PROTOCOL') {
        this.m_setPageTitle('会员服务协议')
      } else {
        this.m_setPageTitle('微行联名' + type + '/电子标签使用协议')
      }
    }
  },
  created() {
    const isCommonProtocol = ETC.COMMON_PROTOCOL[this.$route.query.agreementType]
    const protocolName = this.$route.query.agreementType
    protocolName === 'INTEGRITY_ENTRUST' ? this.maxType = false : this.maxType = true
    this.setTitle(this.currentIssuer && this.currentIssuer.name, protocolName)
    const params = {
      issuer_id: isCommonProtocol ? 0 : (this.$route.query.issuerId || this.currentIssuer.id),
      type: protocolName
    }
    SystemApi.getAgreement(params).then((response) => {
      this.xyText = [response.content[0]]
    })
  }
}
</script>

<style scoped lang="scss">
.etc-agreement{
  width: 100%;
  padding: 10px 24px;
  text-align: justify;
  font-size: 26px;
  color: #666;
  line-height: 44px;
  /*height: 44px;*/
  overflow: scroll;
  word-break: break-all;
  .indent {
    text-indent: 2em;
  }
  .top-space {
    margin-top: 20px;
  }
  .title {
    text-align: center;
    font-weight: 600;
    font-size: 32px;
    line-height: 46px;
    height: 46px;
    color: #000;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .subtitle {
    font-weight: 500;
    font-size: 32px;
    line-height: 46px;
    height: 46px;
    color: #000;
    margin-top: 20px;
  }
  .docImg {
    width: 100%;
  }
  .dot {
    position: relative;
    box-sizing: border-box;
    margin-left: 40px;
    &:after {
      content: '';
      position: absolute;
      top: 18px;
      left: 24px;
      display: inline-block;
      zoom: 1;
      width: 10px;
      height: 10px;
      border-radius: 10px;
      background-color: #0a0b0c;
    }
  }
  .last {
    text-align: right;
    margin: 20px 24px;
  }
}
</style>
